import Device from '../utils/device';
import Cookie from '../utils/cookie';
import Trigger from '../event/trigger';

class MapModalComponentItem {
    constructor(el, index) {
        this.render(el, index);
    }

    init () {
        if( !this.onTransition ){
            $('.c-navbar').addClass('c-navbar-map-modal');
            this.onTransition = false;
            this.body.css('overflow', 'hidden');
            this.html.css('overflow', 'hidden');
            this.app.css('overflow', 'hidden');
            this.element.scrollTop(0);
            this.open();
        }
    }

    open () {
        var delay = 0.2;

        this.element.css('display', 'block');

        this.detailItems.css('display', 'none');
        this.imageItems.css('display', 'none');
        this.mapItems.css('display', 'none');
        this.linkItems.css('display', 'none');

        this.detailItems.eq(this.index).css('display', 'block');
        this.imageItems.eq(this.index).css('display', 'block');
        this.mapItems.eq(this.index).css('display', 'block');
        this.linkItems.eq(this.index).css('display', 'block');

        TweenMax.set( this.detailItems, { x: '100%', opacity: 1 } );
        TweenMax.set( this.imageItems, { x: '100%', opacity: 1 } );
        TweenMax.set( this.mapItems, { x: '100%', opacity: 1 } );
        TweenMax.set( this.linkItems, { x: '100%', opacity: 1 } );

        TweenMax.set( this.detailItems.eq(this.index), { x: '0%' } );
        TweenMax.set( this.imageItems.eq(this.index), { x: '0%' } );
        TweenMax.set( this.mapItems.eq(this.index), { x: '0%' } );

        TweenMax.fromTo( this.element, 1, { x: '100%' }, { x: '0%', ease: Cubic.easeInOut, delay: delay + 0.0 } );

        TweenMax.fromTo( this.detailsBackground, 1, { x: '100%' }, { x: '0%', ease: Cubic.easeInOut, delay: delay + 0.0 } );
        TweenMax.fromTo( this.detailItems.eq(this.index), 0.6, { opacity: 0 }, { opacity: 1, ease: Cubic.easeInOut, delay: delay + 1.0 } );

        TweenMax.fromTo( this.imagesBackground, 1, { x: '100%' }, { x: '0%', ease: Cubic.easeInOut, delay: delay + 0.2 } );
        TweenMax.fromTo( this.imageItems.eq(this.index), 0.6, { opacity: 0 }, { opacity: 1, ease: Cubic.easeInOut, delay: delay + 1.2 } );

        TweenMax.fromTo( this.linksBackground, 1, { x: '100%' }, { x: '0%', ease: Cubic.easeInOut, delay: delay + 0.4 } );
        TweenMax.fromTo( this.linkItems.eq(this.index), 1, { x: '100%' }, { x: '0%', ease: Cubic.easeInOut, delay: delay + 0.4 } );
        TweenMax.fromTo( this.linkItemsList, 0.6, { opacity: 0 }, { opacity: 1, ease: Cubic.easeInOut, delay: delay + 1.4 } );

        TweenMax.fromTo( this.mapsBackground, 1, { x: '100%' }, { x: '0%', ease: Cubic.easeInOut, delay: delay + 0.6 } );
        TweenMax.fromTo( this.mapItems.eq(this.index), 0.6, { opacity: 0 }, { opacity: 1, ease: Cubic.easeInOut, delay: delay + 1.6, onComplete: this.onOpen.bind(this) } );

        TweenMax.fromTo( this.navClose, 0.6, { x: -20, opacity: 0 }, { x: 0, opacity: 1, ease: Cubic.easeOut, delay: 1.8, onComplete: this.onOpen.bind(this) } );
    }

    onOpen () {
        this.onTransition = false;
    }

    close () {
        if( !this.onTransition ){
            this.onTransition = false;

            var delay = 0;

            TweenMax.to( this.navClose, 0.6, { x: -20, opacity: 0, ease: Cubic.easeInOut, delay: 0 } );

            if( this.navContainer.css('display') == "block" ){
                TweenMax.to( this.detailItems, 0.3, { opacity: 0, ease: Cubic.easeIn, delay: delay + 0.0 } );
                TweenMax.to( this.imageItems, 0.3, { opacity: 0, ease: Cubic.easeIn, delay: delay + 0.1 } );
                TweenMax.to( this.linkItemsList, 0.3, { opacity: 0, ease: Cubic.easeIn, delay: delay + 0.2 } );
                TweenMax.to( this.mapItems, 0.3, { opacity: 0, ease: Cubic.easeIn, delay: delay + 0.3 } );
                
                TweenMax.to( this.mapsBackground, 0.6, { x: '-101%', ease: Cubic.easeInOut, delay: delay + 0.6 } );
                TweenMax.to( this.linkItems.eq(this.index), 0.6, { x: '-101%', ease: Cubic.easeInOut, delay: delay + 0.7 } );
                TweenMax.to( this.imagesBackground, 0.6, { x: '-101%', ease: Cubic.easeInOut, delay: delay + 0.8 } );
                TweenMax.to( this.detailsBackground, 0.6, { x: '-101%', ease: Cubic.easeInOut, delay: delay + 1.0 } );
                TweenMax.to( this.element, 1, { x: '-101%', ease: Cubic.easeInOut, delay: delay + 1.2, onComplete: this.onClose.bind(this) } );
            } else {
                TweenMax.to( this.detailItems, 0.3, { opacity: 0, ease: Cubic.easeIn, delay: delay + 0.0 } );
                TweenMax.to( this.imageItems, 0.3, { opacity: 0, ease: Cubic.easeIn, delay: delay + 0.0 } );
                TweenMax.to( this.linkItems, 0.3, { opacity: 0, ease: Cubic.easeIn, delay: delay + 0.0 } );
                TweenMax.to( this.mapItems, 0.3, { opacity: 0, ease: Cubic.easeIn, delay: delay + 0.0 } );

                TweenMax.to( this.element, 0.6, { x: '-101%', ease: Cubic.easeIn, delay: delay + 0.3, onComplete: this.onClose.bind(this) } );
            }
        }
    }

    dispose (){
        this.element.scrollTop(0);
        this.element.css('display', 'none');
        this.body.css('overflow', 'auto');
        this.html.css('overflow', 'auto');
        this.app.css('overflow', 'auto');
    }

    onClose() {
        $('.c-navbar').removeClass('c-navbar-map-modal');
        this.dispose();
    }

    goToSlide ( oldIndex, direction ) {

        this.oldIndex = oldIndex;

        var xFrom = ( direction == "prev" ) ? '-100%' : '100%';
        var xTo = ( direction == "prev" ) ? '100%' : '-100%';

        var speed = 0.6;

        this.detailItems.eq(this.index).css('display', 'block');
        this.imageItems.eq(this.index).css('display', 'block');
        this.linkItems.eq(this.index).css('display', 'block');
        this.mapItems.eq(this.index).css('display', 'block');

        if( this.navContainer.css('display') == "block" ){

            TweenMax.fromTo( this.detailItems.eq(this.index), speed, {x: xFrom, opacity: 1}, { x: '0%', opacity: 1, ease: Cubic.easeInOut, delay: 0 } );
            TweenMax.to( this.detailItems.eq(this.oldIndex), speed, { x: xTo, opacity: 1, ease: Cubic.easeInOut, delay: 0, onComplete: function (){
                this.detailItems.eq(this.oldIndex).css('display', 'none');
            }.bind(this) } );

            TweenMax.fromTo( this.imageItems.eq(this.index), speed, {x: xFrom, opacity: 1}, { x: '0%', opacity: 1, ease: Cubic.easeInOut, delay: 0.1 } );
            TweenMax.to( this.imageItems.eq(this.oldIndex), speed, { x: xTo, opacity: 1, ease: Cubic.easeInOut, delay: 0.1, onComplete: function(){
                this.imageItems.eq(this.oldIndex).css('display', 'none');
            }.bind(this) });

            TweenMax.fromTo( this.linkItems.eq(this.index), speed, {x: xFrom, opacity: 1}, { x: '0%', opacity: 1, ease: Cubic.easeInOut, delay: 0.2 } );
            TweenMax.to( this.linkItems.eq(this.oldIndex), speed, { x: xTo, opacity: 1, ease: Cubic.easeInOut, delay: 0.2, onComplete: function(){
                this.linkItems.eq(this.oldIndex).css('display', 'none');
            }.bind(this) });

            TweenMax.fromTo( this.mapItems.eq(this.index), speed, {x: xFrom, opacity: 1}, { x: '0%', opacity: 1, ease: Cubic.easeInOut, delay: 0.3 } );
            TweenMax.to( this.mapItems.eq(this.oldIndex), speed, { x: xTo, opacity: 1, ease: Cubic.easeInOut, delay: 0.3, onComplete: function(){
                this.mapItems.eq(this.oldIndex).css('display', 'none');
                this.goToSlide_COMPLETE();
            }.bind(this)});

        } else {
            xFrom = ( direction == "prev" ) ? '-100%' : '100%';

            this.detailItems.eq(this.oldIndex).css('display', 'none');
            this.imageItems.eq(this.oldIndex).css('display', 'none');
            this.linkItems.eq(this.oldIndex).css('display', 'none');
            this.mapItems.eq(this.oldIndex).css('display', 'none');

            this.detailItems.eq(this.index).css('display', 'block');
            this.imageItems.eq(this.index).css('display', 'block');
            this.linkItems.eq(this.index).css('display', 'block');
            this.mapItems.eq(this.index).css('display', 'block');

            TweenMax.fromTo( this.detailItems.eq(this.index), speed, {x: xFrom, opacity: 1}, { x: '0%', opacity: 1, ease: Cubic.easeInOut, delay: 0 } );
            TweenMax.fromTo( this.imageItems.eq(this.index), speed, {x: xFrom, opacity: 1}, { x: '0%', opacity: 1, ease: Cubic.easeInOut, delay: 0.05 } );
            TweenMax.fromTo( this.linkItems.eq(this.index), speed, {x: xFrom, opacity: 1}, { x: '0%', opacity: 1, ease: Cubic.easeInOut, delay: 0.1 } );
            TweenMax.fromTo( this.mapItems.eq(this.index), speed, {x: xFrom, opacity: 1}, { x: '0%', opacity: 1, ease: Cubic.easeInOut, delay: 0.15, onComplete: this.goToSlide_COMPLETE.bind(this) } );

            this.element.scrollTop(0);
        }
    }

    goToSlide_COMPLETE () {
        this.onTransition = false;
    }

    buttonClose_CLICK ( e ) {
        this.close();
    }

    buttonArrowPrev_CLICK (){

        if( !this.onTransition ){
            this.onTransition = true;

            var currentIndex = this.index;

            this.index--;
            this.index = ( this.index < 0 ) ? this.numOfItems - 1 : this.index;

            this.goToSlide( currentIndex, 'prev' );
        }
    }

    buttonArrowNext_CLICK () {
        if( !this.onTransition ){
            this.onTransition = true;

            var currentIndex = this.index;

            this.index++;
            this.index = ( this.index >= this.numOfItems ) ? 0 : this.index;

            this.goToSlide( currentIndex, 'next' );
        }
    }

    buttonCenterMap_CLICK ( e ) {
        this.mapData.map.setCenter( this.index );
        this.close();
    }

    buttonResetMap_CLICK ( e ) {
        this.mapData.map.resetCenter();
        this.close();
    }

    onModal_OPEN ( e, data ) {
        this.mapData = data;
        this.index = data.index;
        this.init();
    }

    render (el, index) {
        this.element = $(el);
        this.body = $('body');
        this.html = $('html');
        this.app = $('.app');
        this.onTransition = false;  
        this.mapData;      

        this.detailsContainer = this.element.find('*[data-component="c-map-modal-component-details"]');
        this.detailsBackground = this.element.find('*[data-component="c-map-modal-component-details-background"]');
        this.detailItems = this.element.find('*[data-component="c-map-modal-component-detail"]');

        this.imagesContainer = this.element.find('*[data-component="c-map-modal-component-images"]');
        this.imagesBackground = this.element.find('*[data-component="c-map-modal-component-images-background"]');
        this.imageItems = this.element.find('*[data-component="c-map-modal-component-image"]');

        this.linksContainer = this.element.find('*[data-component="c-map-modal-component-links"]');
        this.linksBackground = this.element.find('*[data-component="c-map-modal-component-links-background"]');
        this.linkItems = this.element.find('*[data-component="c-map-modal-component-link"]');
        this.linkItemsList = this.element.find('*[data-component="c-map-modal-component-link-list"]');

        this.mapsContainer = this.element.find('*[data-component="c-map-modal-component-maps"]');
        this.mapsBackground = this.element.find('*[data-component="c-map-modal-component-maps-background"]');
        this.mapItems = this.element.find('*[data-component="c-map-modal-component-map"]');

        this.navContainer = this.element.find('*[data-component="c-map-modal-component-nav"]');
        this.navClose = this.element.find('*[data-component="c-map-modal-component-nav-close"]');

        this.index = 0;
        this.oldIndex = 0;
        this.numOfItems = this.detailItems.length;

        this.buttonClose = this.element.find('*[data-component="c-map-modal-component-button-close"]');
        this.buttonArrowPrev = this.element.find('*[data-component="c-map-modal-component-button-prev"]');
        this.buttonArrowNext = this.element.find('*[data-component="c-map-modal-component-button-next"]');

        this.buttonCenterMap = this.element.find('*[data-component="c-map-modal-component-button-center-map"]');
        this.buttonResetMap = this.element.find('*[data-component="c-map-modal-component-button-reset-map"]');
        
        $(this.linkItems).find('.hero-modal-list-title').on('click', (evt) => {
            if( !this.onTransition ){
                this.onTransition = true;
    
                var currentIndex = this.index;
    
                this.index = $(evt.currentTarget).data('slice-index');
                // this.index++;
                this.index = ( this.index >= this.numOfItems ) ? 0 : this.index;
    
                this.goToSlide( currentIndex, 'next' );
            }
        })

        $(this.buttonClose).on('click', this.buttonClose_CLICK.bind(this));
        $(this.buttonArrowPrev).on('click', this.buttonArrowPrev_CLICK.bind(this));
        $(this.buttonArrowNext).on('click', this.buttonArrowNext_CLICK.bind(this));

        $(this.buttonCenterMap).on('click', this.buttonCenterMap_CLICK.bind(this));
        $(this.mapItems).on('click', this.buttonCenterMap_CLICK.bind(this));
        $(this.buttonResetMap).on('click', this.buttonResetMap_CLICK.bind(this));

        $(window).on(MapModalComponent.EVENT.MAP_MODAL_OPEN, this.onModal_OPEN.bind(this));
    }
}

class MapModalComponent {
    static get EVENT () {
        return {
            MAP_MODAL_OPEN: 'map-modal-open',
            MAP_MODAL_CLOSE: 'map-modal-close',
        }
    }
    
    constructor(selector) {
        this.all = document.querySelectorAll(selector);
        for ( var i = 0; i < this.all.length; i++ ) {
            this.render(this.all[i], i);
        }
    }

    render (el, index) {
        new MapModalComponentItem(el, index);
    }
}

export default MapModalComponent;
